import styled from 'styled-components/macro';

export const CanvasStyled = styled.canvas``;